// This file is generated by next-core EcmascriptClientReferenceModule.
import { registerClientReference } from "react-server-dom-turbopack/server";
export const Providers = registerClientReference(
    function() { throw new Error("Attempted to call Providers() from the server but Providers is on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component."); },
    "[project]/Documents/00 A Projets/CLAUDE AI/INTEGRAL PHARMA/BILAN DE PREVENTION - PLATEFORME/app/providers.tsx <module evaluation>",
    "Providers",
);
